// https://www.ietf.org/rfc/rfc4122.txt
export function generateUuid() {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const buffer = new Uint8Array(16);
    crypto.getRandomValues(buffer);

    // Set the version and variant bits
    buffer[6] = (buffer[6] & 0x0f) | 0x40; // Version 4
    buffer[8] = (buffer[8] & 0x3f) | 0x80; // Variant 10b

    // Convert the UUID bytes to a string representation
    const hexDigits = '0123456789abcdef';
    let uuid = '';
    for (let i = 0; i < 16; i++) {
      uuid += hexDigits[buffer[i] >> 4];
      uuid += hexDigits[buffer[i] & 0x0f];
      if (i === 3 || i === 5 || i === 7 || i === 9) {
        uuid += '-';
      }
    }

    return uuid;
  } else {
    throw new Error('Crypto API not available.');
  }
}
